import { useRoutes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import { StyledEngineProvider } from '@mui/material/styles';

import routes from 'routes/Router';

import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import './App.css';

const App = () => {
  const pages = useRoutes(routes);

  const toasterOptions = {
    style: {
      fontWeight: 500,
      fontFamily: "'Montserrat', sans-serif",
    },
  };

  return (
    <StyledEngineProvider injectFirst>
      <Toaster toastOptions={toasterOptions} />
      {pages}
    </StyledEngineProvider>
  );
};

export default App;
